import React from 'react';
import { Tooltip, Tag } from 'antd';
import styles from './ShutdownTag.module.scss';

const ShutdownTag = ({ tooltipTitle, content, color = '#2db7f5' }) => {
  return (
    <Tooltip title={tooltipTitle}>
      <Tag
        color={color}
        className={styles.root}
      >
        {content}
      </Tag>
    </Tooltip>
  );
};

export default ShutdownTag;
